import type { LogDetails } from 'shared-types/log'

let isLogEnabledCache: boolean|null = null

// Nothing is ever logged in production: Airbrake is the only reporting channel there.
function isLogEnabled (): boolean {
  if (isLogEnabledCache !== null) {
    return isLogEnabledCache
  }

  if (import.meta.dev) {
    isLogEnabledCache = true
    return true
  }

  if (!import.meta.client) {
    return false
  }

  try {
    const config = useRuntimeConfig()
    isLogEnabledCache = config.public.STAGE !== 'production'
  } catch {
    isLogEnabledCache = false
  }

  return isLogEnabledCache
}

export function getLogMessage (details: LogDetails): string {
  const { scope, fnName, message } = details
  return `[${scope}::${fnName}] ${message}`
}

export function generateError (details: LogDetails): Error {
  const errorMessage = getLogMessage(details)
  return new Error(errorMessage)
}

// Logging is called from catch blocks: it must never become the failure it describes.
export function logDebug (scope: string, message: string, ...args: unknown[]): void {
  try {
    if (!isLogEnabled()) {
      return
    }

    console.debug(`[${scope}] ${message}`, ...args)
  } catch {
    // Console unavailable
  }
}

export function logWarn (scope: string, message: string, ...args: unknown[]): void {
  try {
    if (!isLogEnabled()) {
      return
    }

    console.warn(`[${scope}] ${message}`, ...args)
  } catch {
    // Console unavailable
  }
}

export function logError (scope: string, message: string, ...args: unknown[]): void {
  try {
    if (!isLogEnabled()) {
      return
    }

    console.error(`[${scope}] ${message}`, ...args)
  } catch {
    // Console unavailable
  }
}
